/* ==========================================================================
   LA BOUTIQUE DE VIRGINIE - Advanced Visual Effects v3
   WebGL Shaders, Canvas animations, Interactive nav effects
   ========================================================================== */

(function() {
  'use strict';

  /* ------------------------------------------------------------------
     1. SILK WAVE SHADER - Smooth flowing fabric/aurora for announcement
     Elegant horizontal waves that feel like flowing silk
  ------------------------------------------------------------------ */
  var SilkWaveShader = {
    create: function(canvas, colors, speed) {
      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return null;

      var vertexSource = 'attribute vec2 a_position; void main() { gl_Position = vec4(a_position, 0.0, 1.0); }';

      var fragmentSource = [
        'precision mediump float;',
        'uniform float u_time;',
        'uniform vec2 u_resolution;',
        'uniform vec3 u_color1;',
        'uniform vec3 u_color2;',
        'uniform vec3 u_color3;',
        '',
        'void main() {',
        '  vec2 uv = gl_FragCoord.xy / u_resolution;',
        '  float t = u_time * 0.4;',
        '',
        '  // Smooth horizontal silk waves',
        '  float wave1 = sin(uv.x * 4.0 + t * 1.2) * 0.15;',
        '  float wave2 = sin(uv.x * 6.0 - t * 0.8 + 1.5) * 0.1;',
        '  float wave3 = sin(uv.x * 2.0 + t * 0.5 + 3.0) * 0.2;',
        '',
        '  float blend = uv.x + wave1 + wave2 + wave3;',
        '  blend = smoothstep(0.0, 2.0, blend);',
        '',
        '  // Flowing color blend like silk fabric',
        '  vec3 c = mix(u_color1, u_color2, blend);',
        '  c = mix(c, u_color3, sin(uv.x * 3.0 + t) * 0.3 + 0.15);',
        '',
        '  // Subtle shine highlight',
        '  float shine = pow(sin(uv.x * 8.0 + t * 1.5) * 0.5 + 0.5, 4.0) * 0.15;',
        '  c += shine;',
        '',
        '  gl_FragColor = vec4(c, 1.0);',
        '}'
      ].join('\n');

      return initWebGL(gl, canvas, vertexSource, fragmentSource, colors, speed);
    }
  };

  /* ------------------------------------------------------------------
     2. DEEP SHADER - Subtle animated mesh for nav bar
  ------------------------------------------------------------------ */
  var DeepShader = {
    create: function(canvas, colors, speed) {
      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return null;

      var vertexSource = 'attribute vec2 a_position; void main() { gl_Position = vec4(a_position, 0.0, 1.0); }';

      var fragmentSource = [
        'precision mediump float;',
        'uniform float u_time;',
        'uniform vec2 u_resolution;',
        'uniform vec3 u_color1;',
        'uniform vec3 u_color2;',
        'uniform vec3 u_color3;',
        '',
        'void main() {',
        '  vec2 uv = gl_FragCoord.xy / u_resolution;',
        '  float t = u_time * 0.25;',
        '',
        '  float n1 = sin(uv.x * 3.0 + t) * cos(uv.y * 2.0 + t * 0.7) * 0.5 + 0.5;',
        '  float n2 = sin(uv.x * 2.0 - t * 0.5) * cos(uv.y * 4.0 + t * 0.3) * 0.5 + 0.5;',
        '',
        '  vec3 c = mix(u_color1, u_color2, n1);',
        '  c = mix(c, u_color3, n2 * 0.4);',
        '',
        '  gl_FragColor = vec4(c, 1.0);',
        '}'
      ].join('\n');

      return initWebGL(gl, canvas, vertexSource, fragmentSource, colors, speed);
    }
  };

  /* ------------------------------------------------------------------
     3. HEADER GLOW - Elegant animated gradient line at the bottom
     of the header. Uses fixed brand colors (pink/turquoise).
     No logo color sampling (black logos give bad results).
  ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     3. HEADER AURORA — Soft flowing color blobs that drift slowly
     behind the header. Subtle, dynamic, brand-colored.
     Pure CSS animation approach — no canvas needed.
  ------------------------------------------------------------------ */
  var HeaderAurora = {
    create: function(headerEl) {
      var container = document.createElement('div');
      container.className = 'v-aurora-field';

      // Create 4 vibrant gradient blobs that animate independently
      var blobs = [
        { color: 'rgba(232,97,140,0.22)', size: 350, x: 10, y: 30, dur: 14 },
        { color: 'rgba(46,196,182,0.18)', size: 300, x: 50, y: 60, dur: 18 },
        { color: 'rgba(245,197,66,0.14)', size: 280, x: 85, y: 35, dur: 22 },
        { color: 'rgba(209,74,117,0.12)', size: 240, x: 35, y: 70, dur: 20 }
      ];

      blobs.forEach(function(b, i) {
        var el = document.createElement('div');
        el.className = 'v-aurora-blob v-aurora-blob--' + i;
        el.style.width = b.size + 'px';
        el.style.height = b.size + 'px';
        el.style.background = 'radial-gradient(circle, ' + b.color + ' 0%, transparent 70%)';
        el.style.left = b.x + '%';
        el.style.top = b.y + '%';
        el.style.animationDuration = b.dur + 's';
        container.appendChild(el);
      });

      headerEl.insertBefore(container, headerEl.firstChild);
    }
  };

  /* ------------------------------------------------------------------
     Shared WebGL init helper
  ------------------------------------------------------------------ */
  function initWebGL(gl, canvas, vertexSource, fragmentSource, colors, speed) {
    function compileShader(src, type) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, src);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    var vs = compileShader(vertexSource, gl.VERTEX_SHADER);
    var fs = compileShader(fragmentSource, gl.FRAGMENT_SHADER);
    if (!vs || !fs) return null;

    var program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;

    gl.useProgram(program);

    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);

    var posLoc = gl.getAttribLocation(program, 'a_position');
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    var uTime = gl.getUniformLocation(program, 'u_time');
    var uRes = gl.getUniformLocation(program, 'u_resolution');

    function hexToGL(hex) {
      var r = parseInt(hex.slice(1,3), 16) / 255;
      var g = parseInt(hex.slice(3,5), 16) / 255;
      var b = parseInt(hex.slice(5,7), 16) / 255;
      return [r, g, b];
    }

    // Set color uniforms (up to 3)
    for (var i = 0; i < Math.min(colors.length, 3); i++) {
      var loc = gl.getUniformLocation(program, 'u_color' + (i + 1));
      var c = hexToGL(colors[i]);
      gl.uniform3f(loc, c[0], c[1], c[2]);
    }

    var startTime = Date.now();
    var animId = null;
    var speedMult = speed || 1;

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = canvas.clientWidth;
      var h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(uRes, canvas.width, canvas.height);
    }

    function render() {
      var elapsed = (Date.now() - startTime) / 1000 * speedMult;
      gl.uniform1f(uTime, elapsed);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      animId = requestAnimationFrame(render);
    }

    resize();
    window.addEventListener('resize', resize);
    render();

    return {
      destroy: function() {
        cancelAnimationFrame(animId);
        window.removeEventListener('resize', resize);
      }
    };
  }

  /* ------------------------------------------------------------------
     4. SCROLL REVEAL ANIMATIONS
  ------------------------------------------------------------------ */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    // Stagger reveal: when a group of items becomes visible, reveal them one by one
    var observer = new IntersectionObserver(function(entries) {
      // Group entries that are intersecting
      var visible = entries.filter(function(e) { return e.isIntersecting; });
      visible.forEach(function(entry, i) {
        var delay = i * 100; // 100ms stagger between each item
        setTimeout(function() {
          entry.target.classList.add('v-revealed');
        }, delay);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    // Product grid items get stagger effect
    var gridItems = document.querySelectorAll('.grid-uniform .grid-item');
    gridItems.forEach(function(el) {
      el.classList.add('v-reveal');
      observer.observe(el);
    });

    // Sections get simple fade-in
    var sections = document.querySelectorAll('.section-header, .featured-box, .rich-text');
    sections.forEach(function(el) {
      el.classList.add('v-reveal');
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     5. HEADER SCROLL TRANSFORM
  ------------------------------------------------------------------ */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    var navBar = document.querySelector('.nav-bar');
    var announcement = document.querySelector('.announcement-banner');
    if (!header) return;

    var lastScroll = 0;
    var ticking = false;

    function onScroll() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY > 60) {
        header.classList.add('header--scrolled');
        if (navBar) navBar.classList.add('nav--sticky');
      } else {
        header.classList.remove('header--scrolled');
        if (navBar) navBar.classList.remove('nav--sticky');
      }

      if (announcement) {
        if (scrollY > lastScroll && scrollY > 100) {
          announcement.classList.add('announcement--hidden');
        } else {
          announcement.classList.remove('announcement--hidden');
        }
      }

      lastScroll = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     6. RIPPLE EFFECT - On button/nav clicks
  ------------------------------------------------------------------ */
  function initRippleEffect() {
    var targets = document.querySelectorAll('.btn, .site-nav > li > a, .site-nav > li > button');

    targets.forEach(function(el) {
      el.addEventListener('click', function(e) {
        var rect = el.getBoundingClientRect();
        var ripple = document.createElement('span');
        ripple.className = 'v-ripple';
        var size = Math.max(rect.width, rect.height) * 2;
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
        el.appendChild(ripple);
        setTimeout(function() { ripple.remove(); }, 600);
      });
    });
  }

  /* ------------------------------------------------------------------
     7. CURSOR GLOW TRAIL on nav bar
  ------------------------------------------------------------------ */
  function initNavGlowTrail() {
    var navBar = document.querySelector('.nav-bar');
    if (!navBar) return;

    var glowEl = document.createElement('div');
    glowEl.className = 'v-nav-glow';
    navBar.appendChild(glowEl);

    navBar.addEventListener('mousemove', function(e) {
      var rect = navBar.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      glowEl.style.opacity = '1';
      glowEl.style.transform = 'translate(' + (x - 75) + 'px, ' + (y - 75) + 'px)';
    });

    navBar.addEventListener('mouseleave', function() {
      glowEl.style.opacity = '0';
    });
  }

  /* ------------------------------------------------------------------
     8. ANNOUNCEMENT SLIDER — Rotating messages every 3s + sticky on scroll
  ------------------------------------------------------------------ */
  function initAnnouncementSlider() {
    var banner = document.getElementById('announcementBanner');
    if (!banner) return;

    var slides = banner.querySelectorAll('.v-announce-slide');
    if (slides.length < 2) return;

    var current = 0;

    // Rotate messages
    setInterval(function() {
      slides[current].classList.remove('v-announce-active');
      slides[current].classList.add('v-announce-exit');
      var prev = current;
      current = (current + 1) % slides.length;
      slides[current].classList.add('v-announce-active');
      // Clean exit class after transition
      setTimeout(function() {
        slides[prev].classList.remove('v-announce-exit');
      }, 600);
    }, 3500);

    // Sticky with smooth slide-in/out animation
    var spacer = document.createElement('div');
    spacer.className = 'v-announce-spacer';
    banner.parentNode.insertBefore(spacer, banner.nextSibling);

    var bannerH = banner.offsetHeight;
    spacer.style.height = bannerH + 'px';
    var isSticky = false;

    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY > 200 && !isSticky) {
        isSticky = true;
        // First: set position fixed but off-screen
        banner.classList.add('v-announce-sticky', 'v-announce-entering');
        spacer.classList.add('v-spacer-active');
        // Next frame: animate in
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            banner.classList.remove('v-announce-entering');
            banner.classList.add('v-announce-visible');
          });
        });
      } else if (scrollY <= 150 && isSticky) {
        isSticky = false;
        // Animate out
        banner.classList.add('v-announce-leaving');
        banner.classList.remove('v-announce-visible');
        setTimeout(function() {
          banner.classList.remove('v-announce-sticky', 'v-announce-leaving');
          spacer.classList.remove('v-spacer-active');
        }, 400);
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     9. TYPEWRITER ANIMATION - Fashion-styled for "Coups de Coeur"
     Detects sections containing specific keywords and animates them
  ------------------------------------------------------------------ */
  function initTypewriterSections() {
    var richTexts = document.querySelectorAll('.rich-text');
    richTexts.forEach(function(section) {
      var heading = section.querySelector('.section-header .h1, .section-header p.h1');
      if (!heading) return;
      var text = heading.textContent || '';

      // Detect "Coups de Coeur" section
      if (text.indexOf('Coups') === -1 && text.indexOf('coups') === -1 && text.indexOf('C\u0153ur') === -1) return;

      section.classList.add('v-typewriter-section');

      var fullText = heading.textContent.trim();
      heading.textContent = '';

      // Create a cursor element
      var cursor = document.createElement('span');
      cursor.className = 'v-typewriter-cursor';
      heading.appendChild(cursor);

      // Use IntersectionObserver to trigger on scroll into view
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            observer.unobserve(section);
            typeText(heading, fullText, cursor, function() {
              // When done, add completed class and remove cursor after a pause
              section.classList.add('v-typing-done');
              setTimeout(function() {
                cursor.style.animation = 'none';
                cursor.style.opacity = '0';
                cursor.style.transition = 'opacity 0.5s ease';
              }, 1500);
            });
          }
        });
      }, { threshold: 0.3 });

      observer.observe(section);
    });
  }

  // Split text into proper grapheme clusters (handles emojis with variation selectors)
  function splitGraphemes(text) {
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
      var segmenter = new Intl.Segmenter('fr', { granularity: 'grapheme' });
      var result = [];
      var iter = segmenter.segment(text);
      for (var seg of iter) { result.push(seg.segment); }
      return result;
    }
    // Fallback: Array.from (won't handle all emoji combos but handles most)
    return Array.from(text);
  }

  function typeText(el, text, cursor, callback) {
    var chars = splitGraphemes(text);
    var i = 0;
    var speed = 50;

    function type() {
      if (i < chars.length) {
        var ch = chars[i];
        if (ch === ' ') {
          el.insertBefore(document.createTextNode('\u00A0'), cursor); // non-breaking space as fallback
          // Also add a word-break opportunity
          var wbr = document.createElement('wbr');
          el.insertBefore(wbr, cursor);
        } else {
          var charSpan = document.createElement('span');
          charSpan.textContent = ch;
          charSpan.style.opacity = '0';
          charSpan.style.display = 'inline';
          charSpan.style.animation = 'v-char-appear 0.15s ease forwards';
          el.insertBefore(charSpan, cursor);
        }
        i++;
        var nextSpeed = speed + Math.random() * 25;
        if (ch === '!' || ch === '?') nextSpeed += 180;
        else if (ch === ' ') nextSpeed += 10;
        setTimeout(type, nextSpeed);
      } else {
        if (callback) callback();
      }
    }
    type();
  }

  /* ------------------------------------------------------------------
     INITIALIZATION
  ------------------------------------------------------------------ */
  function init() {
    // 1. Silk wave shader on announcement banner + sparkle icons
    var announcementBanner = document.querySelector('.announcement-banner');
    if (announcementBanner) {
      var bannerCanvas = document.createElement('canvas');
      bannerCanvas.className = 'v-shader-canvas';
      announcementBanner.insertBefore(bannerCanvas, announcementBanner.firstChild);
      SilkWaveShader.create(bannerCanvas, ['#e8618c', '#d14a75', '#2ec4b6'], 0.8);

      // Add sparkle decorations around the text
      var bannerP = announcementBanner.querySelector('p');
      if (bannerP) {
        var sparkleLeft = document.createElement('span');
        sparkleLeft.className = 'v-sparkle v-sparkle--left';
        sparkleLeft.textContent = '\u2726';
        var sparkleRight = document.createElement('span');
        sparkleRight.className = 'v-sparkle v-sparkle--right';
        sparkleRight.textContent = '\u2726';
        bannerP.insertBefore(sparkleLeft, bannerP.firstChild);
        bannerP.appendChild(sparkleRight);
      }
    }

    // 2. Deep shader on nav bar
    var navBar = document.querySelector('.nav-bar');
    if (navBar) {
      var navCanvas = document.createElement('canvas');
      navCanvas.className = 'v-shader-canvas';
      navBar.insertBefore(navCanvas, navBar.firstChild);
      DeepShader.create(navCanvas, ['#1a1a2e', '#16213e', '#0f3460'], 0.5);
    }

    // 3. Header aurora — soft flowing color blobs
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
      HeaderAurora.create(siteHeader);
    }

    // 4. Interactive effects
    initHeaderScroll();
    initRippleEffect();
    initNavGlowTrail();
    initScrollReveal();

    // 5. Announcement bar — rotating messages + sticky
    initAnnouncementSlider();

    // 6. Typewriter animation on "Coups de Coeur" section
    initTypewriterSections();

    // 7. Quick-add AJAX (prevent cart page redirect)
    initAjaxQuickAdd();

    // 8. Back to top button
    initBackToTop();

    // 9. Parallax hover on product card images
    initCardParallax();

    // 10. Recently viewed products
    initRecentlyViewed();

    // 11. (removed — upsell disabled)
  }

  /* ------------------------------------------------------------------
     10. AJAX QUICK-ADD — Targets ONLY the "+" button, not the image
  ------------------------------------------------------------------ */
  function initAjaxQuickAdd() {
    // Attach handler to each "+" button directly — NOT to the overlay
    document.querySelectorAll('.v-quick-add-plus').forEach(function(plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var overlay = plusBtn.closest('.v-quick-add-overlay');
        if (!overlay) return;

        var variantInput = overlay.querySelector('input[name="id"]');
        if (!variantInput) return;

        // AJAX add to cart (no page redirect!)
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantInput.value), quantity: 1 }] })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          // Update cart badge count
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(badge) {
                badge.textContent = cart.item_count;
                badge.classList.remove('hidden-count');
                badge.classList.add('v-cart-bounce');
                setTimeout(function() { badge.classList.remove('v-cart-bounce'); }, 600);
              });
            });

          // Visual feedback: "+" → "✓"
          plusBtn.textContent = '✓';
          plusBtn.classList.add('v-quick-add-success');
          setTimeout(function() {
            plusBtn.textContent = '+';
            plusBtn.classList.remove('v-quick-add-success');
          }, 1200);
        })
        .catch(function(err) { console.error('Quick add error:', err); });
      });
    });

    // NOTE: No handler on the overlay div itself — only the "+" button intercepts clicks.
    // The overlay uses pointer-events:none in CSS; the "+" button uses pointer-events:auto.
  }

  /* ------------------------------------------------------------------
     11. BACK TO TOP BUTTON
  ------------------------------------------------------------------ */
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'v-back-to-top';
    btn.innerHTML = '&#8593;';
    btn.setAttribute('aria-label', 'Retour en haut');
    document.body.appendChild(btn);

    window.addEventListener('scroll', function() {
      if (window.scrollY > 400) {
        btn.classList.add('v-btt-visible');
      } else {
        btn.classList.remove('v-btt-visible');
      }
    }, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ------------------------------------------------------------------
     12. PARALLAX HOVER on product card images
  ------------------------------------------------------------------ */
  function initCardParallax() {
    var cards = document.querySelectorAll('.product-grid-image');
    cards.forEach(function(card) {
      var img = card.querySelector('img');
      if (!img) return;

      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = 'scale(1.04) translate(' + (x * -8) + 'px,' + (y * -8) + 'px)';
      });

      card.addEventListener('mouseleave', function() {
        img.style.transform = '';
      });
    });
  }

  /* ------------------------------------------------------------------
     13. RECENTLY VIEWED PRODUCTS
  ------------------------------------------------------------------ */
  function initRecentlyViewed() {
    // Only run on product pages
    var productJson = document.querySelector('[id^="ProductJson-"]');
    if (!productJson) return;

    try {
      var product = JSON.parse(productJson.textContent);
      var key = 'v_recently_viewed';
      var stored = JSON.parse(localStorage.getItem(key) || '[]');

      // Add current product (avoid duplicates)
      var exists = stored.findIndex(function(p) { return p.handle === product.handle; });
      if (exists > -1) stored.splice(exists, 1);
      stored.unshift({
        handle: product.handle,
        title: product.title,
        url: '/products/' + product.handle,
        image: product.featured_image ? product.featured_image : (product.images && product.images[0] ? product.images[0] : ''),
        price: product.price,
        price_formatted: (product.price / 100).toFixed(2).replace('.', ',') + ' \u20AC'
      });
      // Keep only last 10
      if (stored.length > 10) stored = stored.slice(0, 10);
      localStorage.setItem(key, JSON.stringify(stored));

      // Render section (exclude current product, show max 5)
      var items = stored.filter(function(p) { return p.handle !== product.handle; }).slice(0, 5);
      if (items.length < 1) return;

      // Find insertion point: after related products or after product section
      var insertAfter = document.querySelector('.related-products') || document.getElementById('ProductSection');
      if (!insertAfter) return;

      var section = document.createElement('div');
      section.className = 'v-recently-viewed';
      var html = '<div class="wrapper"><div class="section-header"><p class="h1">Vus r\u00E9cemment</p></div>';
      html += '<div class="v-rv-grid">';
      items.forEach(function(item) {
        var imgSrc = typeof item.image === 'string' ? item.image : '';
        if (imgSrc && imgSrc.indexOf('//') === -1 && imgSrc.indexOf('http') === -1) {
          imgSrc = '//cdn.shopify.com/s/files/' + imgSrc;
        }
        // Force Shopify 300x300 crop for uniform square images
        if (imgSrc && imgSrc.indexOf('cdn.shopify.com') > -1) {
          // Remove any existing size suffix like _100x or _grande etc
          imgSrc = imgSrc.replace(/_(?:\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)/g, '');
          // Add 300x300 crop before extension
          imgSrc = imgSrc.replace(/\.(\w{3,4})(\?|$)/, '_300x300_crop_center.$1$2');
        }
        if (!imgSrc) imgSrc = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="300"%3E%3Crect fill="%23f0f0f0" width="300" height="300"/%3E%3C/svg%3E';
        html += '<a href="' + item.url + '" class="v-rv-item">';
        html += '<div class="v-rv-img"><img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy"></div>';
        html += '<p class="v-rv-title">' + item.title + '</p>';
        html += '<p class="v-rv-price">' + item.price_formatted + '</p>';
        html += '</a>';
      });
      html += '</div></div>';
      section.innerHTML = html;

      insertAfter.parentNode.insertBefore(section, insertAfter.nextSibling);
    } catch(e) { console.error('Recently viewed error:', e); }
  }

  /* ------------------------------------------------------------------
     14. UPSELL — "Complétez votre look" from same collection
  ------------------------------------------------------------------ */
  function initUpsell() {
    // Only on product pages
    if (!document.querySelector('#ProductSection')) return;

    // Get current product handle from URL
    var pathParts = window.location.pathname.split('/');
    var productIdx = pathParts.indexOf('products');
    if (productIdx === -1 || !pathParts[productIdx + 1]) return;
    var currentHandle = pathParts[productIdx + 1].split('?')[0];

    // Find the first collection link in the breadcrumb or product meta
    var collectionLink = document.querySelector('.breadcrumb a[href*="/collections/"]');
    if (!collectionLink) return;

    var collectionUrl = collectionLink.getAttribute('href').split('?')[0];

    // Fetch products from the same collection
    fetch(collectionUrl + '/products.json?limit=10')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products) return;
        var others = data.products.filter(function(p) {
          return p.handle !== currentHandle && p.images && p.images.length > 0;
        }).slice(0, 4);

        if (others.length < 2) return;

        var insertPoint = document.querySelector('.related-products') || document.getElementById('ProductSection');
        if (!insertPoint) return;

        var section = document.createElement('div');
        section.className = 'v-upsell-section';
        var html = '<div class="wrapper"><div class="section-header"><p class="h1">Compl\u00E9tez votre look</p></div>';
        html += '<div class="v-upsell-grid">';
        others.forEach(function(p) {
          var img = p.images[0].src || '';
          // Resize for performance
          if (img.indexOf('cdn.shopify.com') > -1) {
            img = img.replace(/\.(\w{3,4})(\?|$)/, '_300x300_crop_center.$1$2');
          }
          var price = (p.variants[0].price / 1).toFixed(2).replace('.', ',') + ' \u20AC';
          html += '<a href="/products/' + p.handle + '" class="v-upsell-item">';
          html += '<div class="v-upsell-img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>';
          html += '<p class="v-upsell-title">' + p.title + '</p>';
          html += '<p class="v-upsell-price">' + price + '</p>';
          html += '</a>';
        });
        html += '</div></div>';
        section.innerHTML = html;

        // Insert before related products
        insertPoint.parentNode.insertBefore(section, insertPoint);
      })
      .catch(function(e) { console.error('Upsell error:', e); });
  }

  /* ------------------------------------------------------------------
     MOBILE NAV OVERLAY - close menu when tapping outside
  ------------------------------------------------------------------ */
  function initMobileNavOverlay() {
    // Create a real overlay element for click handling
    var overlay = document.createElement('div');
    overlay.className = 'v-nav-overlay';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function() {
      var html = document.documentElement;
      var toggle = document.querySelector('.menu-toggle');
      if (html.classList.contains('show-nav')) {
        html.classList.remove('show-nav');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      initMobileNavOverlay();
    });
  } else {
    init();
    initMobileNavOverlay();
  }

})();
